import styled from 'styled-components';

const StyledBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgba(17, 19, 20, 0.9);
`;

export { StyledBackground };
